const menuIcons = {
  profile: (
    <>
      <circle cx='12' cy='8' r='3.5' />
      <path d='M5 21v-2a7 7 0 0 1 14 0v2' />
    </>
  ),
  terms: (
    <>
      <path d='M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z' />
      <path d='M14 3v6h6M8 13h8M8 17h5' />
    </>
  ),
  administration: (
    <>
      <path d='m12 3 8 3v6c0 4.5-4.8 7.7-8 9-3.2-1.3-8-4.5-8-9V6z' />
      <path d='m8.5 12 2.5 2.5 4.5-5' />
    </>
  ),
  users: (
    <>
      <circle cx='9' cy='8' r='3' />
      <path d='M3 20v-2a6 6 0 0 1 12 0v2M17 5a3 3 0 0 1 0 6M21 20v-2a6 6 0 0 0-4-5.65' />
    </>
  ),
  menu: (
    <>
      <rect x='3' y='3' width='18' height='18' rx='3' />
      <path d='M9 3v18M13 8h4M13 12h4M13 16h4' />
    </>
  ),
  companies: (
    <>
      <path d='M4 21V5l10-2v18M14 8h6v13M2 21h20' />
      <path d='M8 7h2M8 11h2M8 15h2M8 19h2M17 12h1M17 16h1' />
    </>
  ),
  nps: (
    <>
      <path d='M21 13a3 3 0 0 1-3 3h-6l-5 4v-4H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z' />
      <path d='m12 5.5 1.15 2.4 2.65.4-1.9 1.85.45 2.6L12 11.5l-2.35 1.25.45-2.6-1.9-1.85 2.65-.4z' />
    </>
  ),
  logout: (
    <>
      <path d='M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4M10 12h11m-4-4 4 4-4 4' />
    </>
  ),
}

type HeaderMenuIconProps = {
  name: keyof typeof menuIcons
}

const HeaderMenuIcon = ({name}: HeaderMenuIconProps) => (
  <span className='menu-icon' style={{width: 20, height: 20, flex: '0 0 20px', marginRight: 12}}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
      style={{display: 'block', width: 20, height: 20}}
    >
      {menuIcons[name]}
    </svg>
  </span>
)

export {HeaderMenuIcon}
